export default "__VITE_ASSET__DlbKYjdu__"